import { setFlashPhraseIdAction } from '../../store/general/actions';
import { AppThunk } from '../../store/types';
import { removePhrase } from '../../../common/rest/video/removeVideoPhrase';
import { decreasePhraseCount } from '../phraseCountEffects';
import { PhraseListSelectors } from '../../store/phrase-list/selectors';
import { PhraseListActions } from '../../store/phrase-list/actions';
import { getCurrentMovieKey } from '../../store/current-video/selectors';
import { deleteVideoPhraseAction } from '../../store/videos/actions';
import { getAuthUser } from '../../store/general/selectors';
import { EVocabularyPhraseCreateType, EVocabularyPhraseType } from '../../types/common';
import { PlayerController } from '../player/manager/playerController';
import { PhraseDetailsEffects } from '../phrase-details/phrase-details-effects';
import { PhraseNoteTimeScaleEffects } from './phraseNoteTimeScaleEffects';
import { PhraseDetailsSelectors } from '../../store/phrase-details/selectors';
import { batch } from 'react-redux';
import { CaptionsSelectionPopupActions } from '../../store/captions-selection-popup/actions';
import { PhraseDetailsActions } from '../../store/phrase-details/actions';
import { PhraseContextEditorActions } from '../../store/phrase-context-editor/actions';

export class VocabularyEffects {

  public static removePhrase(
    phraseId: number
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const state = getState();
      const {teacherMode} = getAuthUser(state);
      await dispatch(removePhrase(phraseId, teacherMode));
      const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
      if (phrase) {
        dispatch(PhraseListActions.deletePhrase(phraseId));
        const videoId = getCurrentMovieKey(state);
        if (videoId === phrase.videoKey) {
          dispatch(deleteVideoPhraseAction(phrase.id));
        }
        if (phrase && phrase.userGroupId && phrase.type === EVocabularyPhraseType.WORD_SELECTED && phrase.createType === EVocabularyPhraseCreateType.USER) {
          dispatch(decreasePhraseCount(phrase.userGroupId, 1, 1));
        }

        dispatch(PhraseListActions.setNotePopup(false));
      }
    }
  }

  public static flashPhrase(
    phraseId: number
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      dispatch(setFlashPhraseIdAction(phraseId));
      setTimeout(() => {
        dispatch(setFlashPhraseIdAction(0));
      }, 3000);
    }
  }

  public static removePhrasesRelated(
    phraseId: number
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const state = getState();
      PlayerController.getInstance().resetMode();
      const phrase = PhraseListSelectors.findPhraseById(state, phraseId);
      if (phrase) {
        let wordPhraseId = phrase?.wordPhraseId
        if (!wordPhraseId) {
          wordPhraseId = phraseId;
          phraseId = PhraseListSelectors.findPhraseByWordId(state, wordPhraseId)?.id;
        }
        if (wordPhraseId) {
          const videoId = getCurrentMovieKey(state);
          const phrases = PhraseListSelectors.findPhraseByVideoIdAndType(state, videoId, EVocabularyPhraseType.WORD_AND_CONTEXT_SELECTED);
          const wordPhraseUsed = phrases.some(p => p.id !== phraseId && p.wordPhraseId === wordPhraseId);
          if (!wordPhraseUsed) {
            await dispatch(VocabularyEffects.removePhrase(wordPhraseId));
          }
        }
        if (phraseId) {
          await dispatch(VocabularyEffects.removePhrase(phraseId));
        }
        if (wordPhraseId) {
          PhraseDetailsEffects.deleteByPhrase(wordPhraseId);
        }
        PhraseNoteTimeScaleEffects.load();

        const activePhraseId = PhraseDetailsSelectors.getPhraseId(state);
        if (activePhraseId === phraseId || activePhraseId === wordPhraseId) {
          batch(() => {
            dispatch(CaptionsSelectionPopupActions.setSelection(null as any));
            dispatch(CaptionsSelectionPopupActions.setSelectResult(null));
            dispatch(CaptionsSelectionPopupActions.setCurrentSelection(null as any));
            dispatch(PhraseListActions.setPlayCaptionByPhraseId(0));
            dispatch(PhraseListActions.setCurrentPhraseId(0));
            dispatch(PhraseListActions.setPlayPhraseId(0));
            dispatch(PhraseListActions.setNoteId(null as any));
            dispatch(PhraseDetailsActions.disActivate());
            dispatch(PhraseContextEditorActions.updatePhraseContextEditorAction({ phrases: [] }));
          })
        }
      }
    }
  }

}


